import {
    open,
    closeAll
} from '../utils/helpers';

export default (pfx, menusEl, opts = {}) => {
    const primaryFiltersObject = menusEl.find(`.${pfx}mdl-options-primary div`);
    const content = menusEl.find(`.${pfx}mdl-illustration`);
    let cb;

    switch (opts.id) {
        case 'help':
            cb = helpCallbacks;
            break;
        case 'website':
            cb = websiteCallbacks;
            break;
        case 'settings':
            cb = settingsCallbacks;
            break;
        default:
            break;
    }

    primaryFiltersObject.get(0).setAttribute('data-active', true);

    primaryFiltersObject.on('click', function (e) {
        //if (this.getAttribute('data-active') !== 'true') {
        const query = this.getAttribute('data-filter');
        closeAll(primaryFiltersObject);
        open(this);
        cb(query, opts);
        content.attr('data-menu', query);
        //}
    });
}

const websiteCallbacks = (query, opts) => {
    switch (query) {
        case "Save":
            opts.onSave && opts.onSave(opts.editor);
            break;
        case "Preview":
            opts.editor.runCommand('preview');
            break;
        case "Publish":
            opts.onPublish && opts.onPublish(opts.editor);
            break;
        case "View Published Site":
            opts.previewPublished && opts.previewPublished();
            break;
        case "Theme Manager":
            opts.themeManager && opts.themeManager();
            break;
        case "Site History":
            opts.siteHistory && opts.siteHistory();
            break;
        case "Share Website":
            opts.onShare && opts.onShare();
            break;
        case "Delete Website":
            opts.onDelete && opts.onDelete();
            break;
        case "Back to Dashboard":
            opts.dashboard && opts.dashboard();
            break;
        default:
            break;
    }
}

const settingsCallbacks = (query, opts) => {
    switch (query) {
        case "Profile":
            opts.profile && opts.profile();
            break;
        case "Domain":
            opts.domain && opts.domain();
            break;
        case "E-mail":
            opts.mail && opts.mail();
            break;
        case "SEO+":
            opts.seo && opts.seo();
            break;
        case "Social Thumbnails":
            opts.social && opts.social();
            break;
        case "Google Analytics":
            opts.analytics && opts.analytics();
            break;
        case "Construction Page":
            opts.construction && opts.construction();
            break;
        case "Get Feedback":
            opts.getFeedback && opts.getFeedback();
            break;
        case "Delete Website":
            opts.onDelete && opts.onDelete();
            break;
        case "Back to Dashboard":
            opts.dashboard && opts.dashboard();
            break;
        default:
            break;
    }
}

const helpCallbacks = (query, opts) => {
    switch (query) {
        case "Discord":
            opts.discord && opts.discord();
            break;
        case "Video Tutorials":
            opts.videos && opts.videos();
            break;
        case "Documentation":
            opts.docs && opts.docs();
            break;
        case "Dev Mode":
            opts.devModeHelp && opts.devModeHelp();
            break;
        case "Why Upgrade?":
            opts.whyUpgrade && opts.whyUpgrade();
            break;
        case "Submit Feedback":
            opts.submitFeedback && opts.submitFeedback();
            break;
        case "Privacy Policy":
            opts.policy && opts.policy();
            break;
        case "Terms & Conditions":
            opts.terms && opts.terms();
            break;
        default:
            break;
    }
}